import React, {useMemo, useState} from 'react';
import {Button, Card, Col, Modal, Popconfirm, Row, Table} from "antd";
import {DeleteOutlined} from "@ant-design/icons";
import {useDispatch} from "react-redux";
import {deleteEmail} from "../../store/actions/emailAction";

export default function MaillerHistory({action, bdd, mails}) {

	const [isModalOpen, setIsModalOpen] = useState(false);
	const [selectedEmail, setSelectedEmail] = useState(null);

	const dispatch = useDispatch();

	
	
	const history = useMemo(() => {

		const { requete/*, lots*/ } = bdd;
		
		void mails; // Force la dépendance pour le re-render
		const mailsList = [];
		

		if (action === 'requete') {
			requete?.requete_emails &&
			requete?.requete_emails?.forEach((item) => {
				if (requete.requete_id === item.email_requete_id) {
					const email = {
						key: item.email_id,
						destinataire: item.email_destinataire,
						objet: item.email_objet,
						date: item.created_at,
						emetteur: item.email_utilisateur,
						message: item.email_message,
					};

					mailsList.push(email);
				}
			})
		}

		//if (action === 'owner') {
			//console.log(lots);
			/*lot &&
			lot.lot_emails?.forEach((item) => {
				if (lot.lot_id === item.email_lot_id) {
					const email = {
						key: item.email_id,
						objet: item.email_objet,
						date: item.created_at,
						emetteur: item.email_utilisateur,
						message: item.email_message,
					};

					mails.push(email);
				}
			});*/
		//}

		// Tri du plus récent au plus ancien
		return mailsList.sort((a, b) => new Date(b.date) - new Date(a.date));
	}, [bdd, mails, action]);

	const columns = [
		{
			title: 'Date',
			dataIndex: 'date',
			key: 'date',
			width: 115,
			//sorter: (a, b) => new Date(a.date) - new Date(b.date),
		},
		{
			title: 'Objet',
			dataIndex: 'objet',
			key: 'objet',
			ellipsis: true,
		},
		{
			title: '',
			dataIndex: 'key',
			key: 'actions',
			width: 50,
			align: 'right',
			onCell: () => ({
				onClick: (e) => e.stopPropagation(),
			}),
			render: (id) => (
				<Popconfirm
					title="Supprimer cet email de la liste ?"
					onConfirm={() => handleDelete(id)}
				>
					<Button size="small" danger icon={<DeleteOutlined />} />
				</Popconfirm>
			),
		},
	];

	const showModal = (record) => {
		setSelectedEmail(record);
		setIsModalOpen(true);
	};
	const closeModal = () => {
		setIsModalOpen(false);
	};
	const handleDelete = (id) => {
		dispatch(deleteEmail(id));
	};


	return (
		<>
			<Modal
				centered
				width={800}
				footer={null}
				open={isModalOpen}
				title={selectedEmail?.objet}
				onCancel={closeModal}
			>
				<Row>
					<Col md={24}>
						<h4>Destinataire : {selectedEmail?.destinataire || ""}</h4>
						<div
							className={"display-email"}
							dangerouslySetInnerHTML={{
								__html: selectedEmail?.message || "",
							}}
						></div>
					</Col>
				</Row>
			</Modal>
		<Card title="Historique courriels">
			<Table
				size="middle"
				columns={columns}
				dataSource={history}
				pagination={false}
				rowKey="key"
				rowClassName={() => {
					return "row-pointer";
				}}
				onRow={(record) => {
					return { onClick: () => showModal(record) };
				}}
			/>
		</Card>
			</>
	);
}
